export const useScaricaRicevuta = (richiedente) => {
    const debug = process.env.REACT_APP_DEBUG === "true"

    const scaricaRicevuta = (idDominio, iuv, rpp) => {

        console.log({rpp})

        let ccp;

        try {
            // ccp = rpp.filter(item => item.rt.datiPagamento.codiceEsitoPagamento === "0")[0].rt.datiPagamento.CodiceContestoPagamento
            let rt = rpp.filter(item => item.stato === "RT_ACCETTATA_PA")[0].rt
            ccp = rt?.datiPagamento?.CodiceContestoPagamento ?? rt.receiptId
        } catch {
            ccp = rpp.rt.datiPagamento.CodiceContestoPagamento
        }
        
        console.log({ccp})

        // if (rpp.length > 1) {
        //     ccp = rpp.filter(item => item.rt.datiPagamento.codiceEsitoPagamento === 0)[0].rt.datiPagamento.CodiceContestoPagamento
        // } else {
        //     ccp = rpp[0].rt.datiPagamento.CodiceContestoPagamento
        // }

        // [0]?.rt?.datiPagamento?.CodiceContestoPagamento

        let url = process.env.REACT_APP_SERVER_URL + 'rpp/' + idDominio + '/' + iuv + '/' + ccp + '/rt?richiedente=' + richiedente
        if (debug) console.log(url)
        fetch(url, {
            method: 'GET',
            headers: { 
                'Accept': 'application/text'
            }
        })
            .then(res => res.text())
            .then(res => {
                if (debug) console.log(res)
                window.open(process.env.REACT_APP_SERVER_URL + 'pdf_ricevute/' + res)
            })
    }


    return scaricaRicevuta

}